import { request } from "@/service";
import licenseConstants from "./constants";
import { error, success } from "@/plugins/snack/snack";
import EventBus from "@/utils/eventBus";
import License from "./models/license";

export default {
  namespaced: true,
  state: {
    licenses: [],
    alert: {
      status: "",
      message: "",
    },
    loading: false,
    licenseStats: {},
    licenseReviewLogs: [],
    licenseMonthlyTrend: {},
    reviewUser: {},
  },

  mutations: {
    SET_LOADING: (state, payload) => {
      state.loading = payload;
    },

    SET_LICENSE: (state, payload) => {
      state.licenses = [];
      payload.forEach((a) => {
        state.licenses.push(new License(a));
      });
    },

    SET_ALERT: (state, payload) => {
      state.alert = payload || {
        status: "",
        message: "",
      };
    },

    SET_LICENSE_STATS: (state, payload) => {
      state.licenseStats = payload;
    },
    SET_LICENSE_REVIEW_LOGS: (state, payload) => {
      state.licenseReviewLogs = payload;
    },

    SET_LICENSE_MONTHLY_TRENDS: (state, payload) => {
      state.licenseMonthlyTrend = payload;
    },
    SET_REVIEW_USER: (state, payload) => {
      state.reviewUser = payload;
    },
  },

  getters: {
    licenses: (state) => state.licenses,
    loading: (state) => state.loading,
    alert: (state) => state.alert,
    licenseStats: (state) => state.licenseStats,
    licenseReviewLogs: (state) => state.licenseReviewLogs,
    licenseMonthlyTrend: (state) => state.licenseMonthlyTrend,
    reviewUser: (state) => state.reviewUser,
  },

  actions: {
    setLoader({ commit }, payload) {
      commit("SET_LOADING", payload);
    },

    getReviewStageUser({ commit }, payload) {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true);
      request("get", licenseConstants.reviewUser.list(payload))
        .then((response) => {
          commit("SET_REVIEW_USER", response.data.data);
        })
        .catch((error) => {
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },
    getLicenseStats({ commit }, payload) {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true);
      request("post", licenseConstants.licenseStats, payload)
        .then((response) => {
          commit("SET_LICENSE_STATS", JSON.parse(response.data.data || "{}"));
        })
        .catch((error) => {
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },

    getLicenseReviewLogs({ commit }, payload) {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true);
      let queryUrl = licenseConstants.licenseReviewLogs.list(payload);

      request("get", queryUrl)
        .then((response) => {
          commit("SET_LICENSE_REVIEW_LOGS", response.data.data);
        })
        .catch((error) => {
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },

    getLicenseMonthlyTrend({ commit }, payload) {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true);
      request("post", licenseConstants.licenseMonthlyTrend, payload)
        .then((response) => {
          commit(
            "SET_LICENSE_MONTHLY_TRENDS",
            JSON.parse(response.data.data || "{}")
          );
        })
        .catch((error) => {
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },

    getLicenses({ commit }, payload) {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true);
      let queryUrl = licenseConstants.license.list(payload);

      request("get", queryUrl)
        .then((res) => {
          commit("SET_LICENSE", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((err) => {
          commit("SET_LOADING", false);
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },
    sendPrbLetter({ commit }, payload) {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true);
      request("post", licenseConstants.sendPrbLetter, payload)
        .then(() => {
          EventBus.$emit("refresh-interview-page");
          success("Inverview notifcation sent successfully");
          commit("SET_LOADING", false);
        })
        .catch((err) => {
          commit("SET_LOADING", false);
          error(err.response.data.message);
        });
    },

    approveAll({ commit, dispatch }, payload) {
      commit("SET_ALERT", null);
      commit("SET_LOADING", true);
      request("post", licenseConstants.approveAll, payload)
        .then(() => {
          dispatch("getLicenses");
          success("Successfully approved all selected license applications");
          commit("SET_LOADING", false);
        })
        .catch((err) => {
          commit("SET_LOADING", false);
          error(err.response.data.message);
        });
    },

    forward(context, payload) {
      return request("post", licenseConstants.forward, payload);
    },

    rewind(context, payload) {
      return request("post", licenseConstants.rewind, payload);
    },

    hold(context, payload) {
      return request("post", licenseConstants.hold, payload);
    },

    decline(context, payload) {
      return request("post", licenseConstants.decline, payload);
    },

    forwardPRB(context, payload) {
      return request("post", licenseConstants.forwardPRB, payload);
    },

    generateReport(context, payload) {
      return request("post", licenseConstants.generateReport, payload);
    },

    getSubscriptions(context, payload) {
      return request("get", licenseConstants.subscriptions.list(payload));
    },

    getReceiptReport(context, payload) {
      return request("post", licenseConstants.paymentReceipt, payload);
    },

    getCPD(context, payload) {
      return request("post", licenseConstants.cpd, payload);
    },
  },
};
